import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

// Tabs
import AircraftLogbookReportActionPartsReplacementsTab from './AircraftLogbookReportActionPartsReplacementsTab';
import AircraftLogbookReportActionMaintenanceOperationalRestrictionTab from './AircraftLogbookReportActionMaintenanceOperationalRestrictionTab';

import LogbookSignatureModal from '../../LogbookAppIntegration/LogbookSignatureModal';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class AircraftLogbookReportActionsTab extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
          overlay: {
            message: '',
            type: '',
            status: 'closed',
          },
          redirect_url: false,
          loaded: 0,
          logbook_app: this.props.logbook_app,
          action_parts_modal: false,
          aircraft_logbook_id: this.props.aircraft_logbook_id,
          aircraft_logbook_report_id: '',
          report_action_id: '',
          base_id: '',
          action: '',
          deferred_item: 0,
          mandatory_inspection: 0,
          date: '',
          tools: 0,
          maintenance_flight: 0,
          executor_user_id: '',
          inspector_user_id: '',
          flight_hours_next_maintenance_intervention: '',
          system_id: null,
          next_maintenance_intervention_type_id: null,
          reports: {},
          report_actions: {},
          report_action_parts_replacements: [],
          report_action_deferred_items: [],
          maintenance_operational_restriction_list: [],
          aircraft_logbook_reports_list: [],
          users_list: [],
          bases_list: [],
          systems_list: [],
          maintenance_intervention_types_list: [],
          approvals_reports: [],
          approval_type: '',
          email: '',
          password: '',
          showLogbookSignatureModal: false,
          signature_modal_title: '',
          signature_modal_subtitle: '',
          signature_modal_confirmation: '',
        };
        this.openDeferredModal = this.openDeferredModal.bind(this);
        this.openPartsModal = this.openPartsModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleApproval = this.handleApproval.bind(this);
        this.handleLogbookSignatureSubmit = this.handleLogbookSignatureSubmit.bind(this);
        this.add = this.add.bind(this);
        this.rtsApproval = this.rtsApproval.bind(this);
        this.captainAcceptance = this.captainAcceptance.bind(this);
        this.delete = this.delete.bind(this);
      }

      // Handlers
      handleChange (name, event) {
        var change = {};
        change[name] = event.target.value;
        this.setState(change);
      }
    
      handleSelectChange(name, event) {
        var change = {};
        if(event == null) {
          change[name] = null;
        } else {
          change[name] = event.value;
        }
        this.setState(change);
      }

      handleToggleChange (name, event) {
        var change = {};
        if (event.target.checked === true) {
          var value = 1;
        } else {
          var value = 0;
        }
        change[name] = value;
        this.setState(change);
      }

      getDefaultNextMaintenanceTypeId() {
        const release = this.props.airworthiness_releases;
        if (release && release.next_maintenance_intervention_type_id) {
          return release.next_maintenance_intervention_type_id;
        }
        return null;
      }

      formatInputValue = (rawValue) => {
        if (!rawValue) {
          return '';
        }

        let [inteiro, decimal] = rawValue.split('.');

        // Ajusta a parte decimal para sempre ter um dígito
        decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

        return `${inteiro}.${decimal}`;
      };

      handleChangeDecimal = (name, event) => {
        let rawInputValue = this.state.rawInputValue;
      
        let inputValue = event.target.value;
      
        // Se o input estiver vazio, limpa rawInputValue
        if (inputValue === '') {
          rawInputValue = '';
        } else if (/^\d+$/.test(inputValue)) {
          // Se for um número inteiro, atualiza rawInputValue
          rawInputValue = inputValue;
        } else {
          let newChar = inputValue.slice(-1);
      
          // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
          if (!/^[0-9.,]$/.test(newChar)) {
            // Caractere inválido, não faz nada
            return;
          }
      
          // Substitui vírgula por ponto
          if (newChar === ',') {
            newChar = '.';
          }
      
          // Verifica se já existe um ponto decimal
          let hasDecimal = rawInputValue.includes('.');
      
          // Impede que "0" seja o primeiro dígito
          if (rawInputValue === '' && newChar === '0') {
            return;
          }
      
          // Determina se está adicionando ou removendo um caractere
          if (event.nativeEvent.inputType === 'deleteContentBackward') {
            // Removendo um caractere
            rawInputValue = rawInputValue.slice(0, -1);
          } else if (hasDecimal && newChar !== '.') {
            // Substitui o dígito após o ponto decimal
            let parts = rawInputValue.split('.');
            parts[1] = newChar;
            rawInputValue = parts.join('.');
          } else {
            // Adicionando um caractere
            rawInputValue += newChar;
          }
        }
      
        // Formata o valor para exibição com base em rawInputValue
        let formattedValue = this.formatInputValue(rawInputValue);
      
        // Atualiza o estado
        this.setState({
          [name]: formattedValue,
          rawInputValue: rawInputValue
        });
      };

      // LM
      componentWillReceiveProps(newProps) {
        if(this.state.loaded === 0) {
          this.setState({
            logbook_app: newProps.logbook_app,
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            loaded: 1,
          });
        }

        if(typeof newProps.reports !== 'undefined' && newProps.reports !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            reports: newProps.reports,
          });
        }

        if(typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            report_actions: newProps.report_actions,
          });
        }

        if(typeof newProps.report_action_parts_replacements !== 'undefined' && newProps.report_action_parts_replacements !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            report_action_parts_replacements: newProps.report_action_parts_replacements,
          });
        }

        if(typeof newProps.report_action_deferred_items !== 'undefined' && newProps.report_action_deferred_items !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            report_action_deferred_items: newProps.report_action_deferred_items,
          });
        }
        
        if(typeof newProps.maintenance_operational_restriction_list !== 'undefined' && newProps.maintenance_operational_restriction_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            maintenance_operational_restriction_list: newProps.maintenance_operational_restriction_list,
          });
        }

        if(typeof newProps.aircraft_logbook_reports_list !== 'undefined' && newProps.aircraft_logbook_reports_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            aircraft_logbook_reports_list: newProps.aircraft_logbook_reports_list,
          });
        }

        if(typeof newProps.users_list !== 'undefined' && newProps.users_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            users_list: newProps.users_list,
          });
        }

        if(typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            bases_list: newProps.bases_list,
          });
        }

        if(typeof newProps.systems_list !== 'undefined' && newProps.systems_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            systems_list: newProps.systems_list,
          });
        }

        if(typeof newProps.maintenance_intervention_types_list !== 'undefined' && newProps.maintenance_intervention_types_list !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            maintenance_intervention_types_list: newProps.maintenance_intervention_types_list,
          });
        }

        if(typeof newProps.airworthiness_releases !== 'undefined' && newProps.airworthiness_releases !== null) {
          const hasNextMaintenanceType = typeof newProps.airworthiness_releases.next_maintenance_intervention_type_id !== 'undefined' && newProps.airworthiness_releases.next_maintenance_intervention_type_id !== null;
          const defaultNextMaintenance = hasNextMaintenanceType ? newProps.airworthiness_releases.next_maintenance_intervention_type_id : null;
          if (this.state.next_maintenance_intervention_type_id === null) {
            this.setState({
              next_maintenance_intervention_type_id: defaultNextMaintenance,
            });
          }
        }

        if(typeof newProps.approvals_reports !== 'undefined' && newProps.approvals_reports !== null) {
          this.setState({
            aircraft_logbook_id: newProps.aircraft_logbook_id,
            approvals_reports: newProps.approvals_reports,
          });
        }
      }

      openDeferredModal (id) {
        var self = this;
        self.setState({
          report_action_id: id,
          action_deferred_items_modal: true,
        });
      }

      openPartsModal (id) {
        var self = this;
        self.setState({
          report_action_id: id,
          action_parts_modal: true,
        });
      }
    
      closeModal(responseJson) {
        this.props.handleAlert('', '', 'open');
        this.setState({
          action_parts_modal: false,
          action_deferred_items_modal: false,
        }, this.props.updateData());
      }

      handleFormSubmit(e) {
        e.preventDefault();
        this.handleApproval(null, 'report');
      }

      // Após clicar para aprovar o reporte
      handleApproval(id, type) {
        if (type === 'report') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta ação de manutenção para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.add();
          }
        }

        if (type === 'rtsApproval') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              report_action_id: id,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aprovação de RTS no Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.rtsApproval();
          }
        }

        if (type === 'captainAcceptance') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              report_action_id: id,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aceitação de Comandante no Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.captainAcceptance();
          }
        }

        if (type === 'delete') {
          // Se tiver integração com o Logbook App, chama a função de integração
          if (this.props.logbook_app == 1) {
            // Abrimos o modal para solicitar as credenciais do Logbook App
            this.setState({
              report_action_id: id,
              approval_type: type,
              signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta ação de manutenção para o Logbook App?',
              signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
              signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
              showLogbookSignatureModal: true
            });
          } else {
            this.delete();
          }
        }
      }

      // Após preencher as credenciais do Logbook App
      handleLogbookSignatureSubmit(credentials) {
        // Recebe { email, password } do modal e atualiza o state
        this.setState({
          email: credentials.email,
          password: credentials.password,
          showLogbookSignatureModal: false
        }, () => {
          // Após informar as credenciais, chama a função de aprovação interna
          if (this.state.approval_type === 'report') {
            this.add();
          }
          if (this.state.approval_type === 'rtsApproval') {
            this.rtsApproval();
          }
          if (this.state.approval_type === 'captainAcceptance') {
            this.captainAcceptance();
          }
          if (this.state.approval_type === 'delete') {
            this.delete();
          }
        });
      }

      // Cadastra a nova ação de manutenção e, se estiver ativada a integração, envia para o Logbook App
      add() {
        this.props.handleAlert('', '', 'open');
        const datasave = {
          email: this.state.email,
          password: this.state.password,
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
          base_id: this.state.base_id,
          action: this.state.action,
          deferred_item: this.state.deferred_item,
          mandatory_inspection: this.state.mandatory_inspection,
          date: this.state.date,
          tools: this.state.tools,
          maintenance_flight: this.state.maintenance_flight,
          executor_user_id: this.state.executor_user_id,
          inspector_user_id: this.state.inspector_user_id,
          flight_hours_next_maintenance_intervention: this.state.flight_hours_next_maintenance_intervention,
          system_id: this.state.system_id,
          next_maintenance_intervention_type_id: this.state.next_maintenance_intervention_type_id,
        };
        var url = config.get('api') + '/aeronave/diario/reporte/acoes';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({
                aircraft_logbook_report_id: '',
                base_id: '',
                action: '',
                deferred_item: 0,
                mandatory_inspection: 0,
                date: '',
                tools: 0,
                maintenance_flight: 0,
                executor_user_id: '',
                inspector_user_id: '',
                flight_hours_next_maintenance_intervention: '',
                system_id: null,
                next_maintenance_intervention_type_id: self.getDefaultNextMaintenanceTypeId(),
                report_action_id: '',
                approval_type: '',
                email: '',
                password: '',
                signature_modal_title: '',
                signature_modal_subtitle: '',
                signature_modal_confirmation: ''
              });
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App
      rtsApproval() {
        this.props.handleAlert('', '', 'open');
        const datasave = {
          report_action_id: this.state.report_action_id,
          email: this.state.email,
          password: this.state.password
        };
        var url = config.get('api') + '/aeronave/diario/reporte/acao/aprovar';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              report_action_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App
      captainAcceptance() {
        this.props.handleAlert('', '', 'open');
        const datasave = {
          report_action_id: this.state.report_action_id,
          email: this.state.email,
          password: this.state.password
        };
        var url = config.get('api') + '/aeronave/diario/reporte/acao/aceitar';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              report_action_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch((error) => {
            console.error(error);
          });
        });
      }

      // Deleta a ação de manutenção e, se estiver ativada a integração, arquiva no Logbook App
      delete () {
        var confirm = window.confirm('Are you sure that you want to delete this report action?');
        if (confirm) {
          this.props.handleAlert('', '', 'open');
          const datasave = {
            report_action_id: this.state.report_action_id,
            email: this.state.email,
            password: this.state.password
          };
          var url = config.get('api') + '/aeronave/diario/reporte/acao/deletar';
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function(value) {
            fetch(url, { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({
                report_action_id: '',
                approval_type: '',
                email: '',
                password: '',
                signature_modal_title: '',
                signature_modal_subtitle: '',
                signature_modal_confirmation: ''
              });
              if (responseJson.status === 'success') {
                self.props.updateData(responseJson);
              } else {
                self.props.handleAlert(responseJson.message, responseJson.status, 'open');
              }
            }).catch((error) => {
              console.error(error);
            });
          });
        }
      }
    
      render() {
        var self = this;
        return (
      <div>
        <RequestApi ref={'request_api'} />      
        <h3 className="page-title pull-left">Maintenance Actions</h3>
        <div className="clearfix"></div>
        <hr/>
        <form onSubmit={this.handleFormSubmit}>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Report</label>
                <Select
                  className="form-group"
                  name="aircraft_logbook_report_id"
                  value={this.state.aircraft_logbook_report_id}
                  searchable={true}
                  placeholder={'Selecionar reporte'}
                  onChange={this.handleSelectChange.bind(this, 'aircraft_logbook_report_id')}
                  options={this.state.aircraft_logbook_reports_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Base</label>
                <Select
                  className="form-group"
                  name="base_id"
                  value={this.state.base_id}
                  searchable={true}
                  placeholder={'Selecionar base'}
                  onChange={this.handleSelectChange.bind(this, 'base_id')}
                  options={this.state.bases_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Deferred Item</label>
                <br/>
                <Toggle
                  aria-label="deferred_item"
                  name="deferred_item"
                  checked={this.state.deferred_item}
                  onChange={this.handleToggleChange.bind(this, 'deferred_item')}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>RII</label>
                <br/>
                <Toggle
                  aria-label="mandatory_inspection"
                  name="mandatory_inspection"
                  checked={this.state.mandatory_inspection}
                  onChange={this.handleToggleChange.bind(this, 'mandatory_inspection')}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>System</label>
                <Select
                  className="form-group"
                  name="system_id"
                  value={this.state.system_id}
                  searchable={true}
                  placeholder={'Select'}
                  onChange={this.handleSelectChange.bind(this, 'system_id')}
                  options={this.state.systems_list}
                  required
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>Next Maintenance Intervention Type</label>
                <Select
                  className="form-group"
                  name="next_maintenance_intervention_type_id"
                  value={this.state.next_maintenance_intervention_type_id}
                  searchable={true}
                  placeholder={'Select'}
                  onChange={this.handleSelectChange.bind(this, 'next_maintenance_intervention_type_id')}
                  options={this.state.maintenance_intervention_types_list}
                  required
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Date</label>
                <InputMask value={this.state.date} name="date" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'date')} placeholder="dd/mm/aaaa hh:mm" required />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Hours Until Next Maintenance Intervention:</label>
                <input value={this.state.flight_hours_next_maintenance_intervention} name="flight_hours_next_maintenance_intervention" className="form-control" onChange={this.handleChangeDecimal.bind(this, 'flight_hours_next_maintenance_intervention')} placeholder="hh.m" required />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Tools</label>
                <br/>
                <Toggle
                  aria-label="tools"
                  name="tools"
                  checked={this.state.tools}
                  onChange={this.handleToggleChange.bind(this, 'tools')}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-group">
                <label>Requires maintenance flight</label>
                <br/>
                <Toggle
                  aria-label="maintenance_flight"
                  name="maintenance_flight"
                  checked={this.state.maintenance_flight}
                  onChange={this.handleToggleChange.bind(this, 'maintenance_flight')}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <div className="form-group">
                <label>Executor</label>
                <Select
                  className="form-group"
                  name="executor_user_id"
                  value={this.state.executor_user_id}
                  searchable={true}
                  placeholder={'Selecionar executor'}
                  onChange={this.handleSelectChange.bind(this, 'executor_user_id')}
                  options={this.state.users_list}
                  required
                />
              </div>
            </div>
            {this.state.mandatory_inspection == 1 &&
              <div className="col-md-3">
                <div className="form-group">
                  <label>Inspector</label>
                  <Select
                    className="form-group"
                    name="inspector_user_id"
                    value={this.state.inspector_user_id}
                    searchable={true}
                    placeholder={'Selecionar inspetor'}
                    onChange={this.handleSelectChange.bind(this, 'inspector_user_id')}
                    options={this.state.users_list}
                    required
                  />
                </div>
              </div>
            }
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Action</label>
                <br/>
                <textarea style={{ height: 200 }} type="text" name="action" className="form-control" value={this.state.action} onChange={this.handleChange.bind(this, 'action')} required />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <button type="submit" className="btn btn-block btn-primary"><i className="fa fa-fw fa-save"></i> Cadastrar</button>
              </div>
            </div>
          </div>
        </form>
        <hr/>
        <div className="table-responsive">
          <table className="table table-bordered table-hover table-striped">
            <caption>Maintenance Actions</caption>
            <thead>
              <tr>
                <th className="text-center vcenter">Item</th>
                <th className="text-center vcenter">Base</th>
                <th className="text-center vcenter">Action</th>
                <th className="text-center vcenter">System</th>
                <th className="text-center vcenter">Next Mnt Type</th>
                <th className="text-center vcenter">Date</th>
                <th className="text-center vcenter">Hrs Next Mnt</th>
                <th className="text-center vcenter">RII</th>
                <th className="text-center vcenter">Tools</th>
                <th className="text-center vcenter">Executor</th>
                <th className="text-center vcenter">Inspector</th>
                <th className="text-center vcenter">RTS</th>
                <th className="text-center vcenter">RTS Approval</th>
                <th className="text-center vcenter">Captain</th>
                <th className="text-center vcenter">Captain Acceptance</th>
                <th className="text-center vcenter">Parts Replacement</th>
                <th className="text-center vcenter">Deferred Item</th>
                <th className="text-center vcenter">Actions</th>
              </tr>
            </thead>
            <tbody id="report_actions">
            {Object.keys(self.state.report_actions).map(function(k) {
              var report_action = self.state.report_actions[k];
              return(
              <tr className="text-center" key={report_action.id}>
                <td>{report_action.item}</td>
                <td>{report_action.base.abbreviation}</td>
                <td>{report_action.action}</td>
                <td>{report_action.system_name || (report_action.aircraft_logbook_report && report_action.aircraft_logbook_report.system ? report_action.aircraft_logbook_report.system.name : '')}</td>
                <td>{report_action.next_maintenance_intervention_type_name || (report_action.aircraft_logbook_report && report_action.aircraft_logbook_report.next_maintenance_intervention_type ? report_action.aircraft_logbook_report.next_maintenance_intervention_type.type : '')}</td>
                <td>{report_action.date_str}</td>
                <td>{report_action.flight_hours_next_maintenance_intervention_str}</td>
                <td>{report_action.mandatory_inspection_str}</td>
                <td>{report_action.tools_str}</td>
                <td>{report_action.executor_user_name}</td>
                <td>{report_action.inspector_user_name}</td>
                <td>{report_action.rts_user_name}</td>
                {
                  (report_action.rts_approval_date == null) ?
                    <td>
                      <button onClick={() => {self.handleApproval(report_action.id, 'rtsApproval')}} className="btn btn-success btn-sm button-inline">
                        <i className="fa fa-check"></i>
                      </button>
                    </td>
                  :
                    <td>{report_action.rts_approval_date_str}</td>
                }
                <td>{report_action.captain_user_name}</td>
                {
                  (report_action.captain_acceptance_date == null) ?
                    <td>
                      <button onClick={() => {self.handleApproval(report_action.id, 'captainAcceptance')}} className="btn btn-success btn-sm button-inline">
                        <i className="fa fa-check"></i>
                      </button>
                    </td>
                  :
                    <td>{report_action.captain_acceptance_date_str}</td>
                }
                <td>
                  <div>
                    <button onClick={() => self.openPartsModal(report_action.id)} className="btn btn-primary btn-sm"><i className="fa fa-gears"></i></button>
                  </div>
                </td>
                <td>
                  {report_action.deferred_item == 1 ?
                    <button onClick={() => self.openDeferredModal(report_action.id)} className="btn btn-primary btn-sm"><i className="fa fa-hourglass-start"></i></button>
                  :
                    <button className="btn btn-primary btn-sm" disabled><i className="fa fa-hourglass-start"></i></button>
                  }
                </td>
                <td>
                  {
                    (report_action.rts_approval_date == null && report_action.captain_acceptance_date == null) ?
                      <button onClick={() => {self.handleApproval(report_action.id, 'delete')}} className="btn btn-danger btn-sm button-inline"><i className="fa fa-trash"></i></button>
                    :
                      <button className="btn btn-danger btn-sm button-inline" disabled><i className="fa fa-trash"></i></button>
                  }
                </td>
              </tr>
              );
            })}
            </tbody>
          </table>
        </div>
        <Modal show={this.state.action_parts_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Part's Replacement</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <AircraftLogbookReportActionPartsReplacementsTab handleAlert={this.props.handleAlert} handleMessage={this.props.handleMessage} updateData={this.props.updateData} report_action_id={this.state.report_action_id} reports={this.state.reports} report_actions={this.state.report_actions} report_action_parts_replacements={this.state.report_action_parts_replacements} engines_list={this.props.engines_list} />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
        <Modal show={this.state.action_deferred_items_modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Deferred Item</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <AircraftLogbookReportActionMaintenanceOperationalRestrictionTab handleAlert={this.props.handleAlert} handleMessage={this.props.handleMessage} updateData={this.props.updateData} report_action_id={this.state.report_action_id} reports={this.state.reports} report_actions={this.state.report_actions} report_action_deferred_items={this.state.report_action_deferred_items} maintenance_operational_restriction_list={this.state.maintenance_operational_restriction_list} />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
        {/* Modal de assinatura do LogbookApp */}
        <LogbookSignatureModal
          show={this.state.showLogbookSignatureModal}
          onHide={() => this.setState({ showLogbookSignatureModal: false })}
          onSubmit={this.handleLogbookSignatureSubmit}
          title={this.state.signature_modal_title}
          subtitle={this.state.signature_modal_subtitle}
          confirmation={this.state.signature_modal_confirmation}
        />
      </div>
    );
  }
}

export default AircraftLogbookReportActionsTab;



// WEBPACK FOOTER //
// ./src/Components/AircraftLogbooks/Elements/AircraftLogbookReportActionsTab.js